import { fetchNewPartnerById } from 'legacy/lut/services/partner/fetchNewPartnerById'
import { fetchPartnerRequestById } from 'legacy/lut/services/partner/fetchPartnerRequestById'

import { PartnerHelper } from 'onboarding/classes/helpers/PartnerHelper'

export const fetchPartner = (partnerId: string) => {
  if (PartnerHelper.isDummyPartnerRequest(partnerId)) {
    return fetchNewPartnerById(partnerId, {
      isForce: true,
      cacheKey: 'onb-form-data-fetch-new-partner',
    })
  }

  return fetchPartnerRequestById(partnerId, {
    isForce: true,
    cacheKey: 'onb-form-data-fetch-partner',
  })
}
